module.exports = __webpack_public_path__ + "img/关注微信公众号.8eadb737.jpg";